import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const EmpresaContext = createContext();

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function EmpresaProvider({ children }) {
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchEmpresas = async () => {
    try {
      const response = await axios.get(`${API}/empresas`);
      // Cada empresa puede traer my_role: "owner" | "read" | "write".
      // Si el backend aún no lo envía, asumimos "owner" (empresa propia).
      const data = (response.data || []).map((e) => ({
        ...e,
        my_role: e.my_role || 'owner',
      }));
      setEmpresas(data);
      // Mantener la selección sincronizada con los datos frescos
      // (o seleccionar la primera si no hay ninguna seleccionada).
      setSelectedEmpresa((prev) => {
        if (!prev) return data[0] || null;
        return data.find((e) => e.id === prev.id) || data[0] || null;
      });
    } catch (error) {
      console.error('Error fetching empresas:', error);
    } finally {
      setLoading(false);
    }
  };

  const seedData = async () => {
    try {
      await axios.post(`${API}/seed`);
    } catch (error) {
      console.error('Error seeding data:', error);
    }
  };

  useEffect(() => {
    const init = async () => {
      await seedData();
      await fetchEmpresas();
    };
    init();
  }, []);

  const value = {
    empresas,
    selectedEmpresa,
    setSelectedEmpresa,
    loading,
    refreshEmpresas: fetchEmpresas,
    API
  };

  return (
    <EmpresaContext.Provider value={value}>
      {children}
    </EmpresaContext.Provider>
  );
}

export function useEmpresa() {
  const context = useContext(EmpresaContext);
  if (!context) {
    throw new Error('useEmpresa must be used within an EmpresaProvider');
  }
  return context;
}
